module.exports = __webpack_public_path__ + "static/avenir-bold-1d7e5bd0f08bf910ab961cf48f82722f.woff";